import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import styles from './UnitImages.module.css';

const UnitImages = ({ images }) => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  return (
    <div className={styles.unitImages}>
      <div className={styles.heroContainer}>
        <img
          src={images[0]}
          alt="Main unit image"
          className={styles.heroImage}
          onClick={() => { setIndex(0); setOpen(true); }}
          style={{ cursor: 'pointer' }}
        />
      </div>

      <div className={styles.imageGallery}>
        {images.map((img, idx) => (
          <img
            key={idx}
            src={img}
            alt={`Gallery ${idx}`}
            className={styles.galleryImage}
            onClick={() => { setIndex(idx); setOpen(true); }}
          />
        ))}
      </div>

      {open && (
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={images.map((img) => ({ src: img }))}
          plugins={[Thumbnails]}
          thumbnails={{ position: 'bottom' }}
          index={index}
        />
      )}
    </div>
  );
};

export default UnitImages;
